// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Eraser: React.FC<{ width?: number; height?: number }> = ({ width = 14, height = 13 }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 13 11">
            <path
                fill="currentColor"
                d="M4.27757353,9.53333333 L7.21691176,9.53333333 L8.77022059,8.04375 L4.61213235,4.05625 L1.60110294,6.96666667 L4.27757353,9.53333333 Z M5.35294118,11 L4.27757353,11 C3.87132353,11 3.46507353,10.8395833 3.17830882,10.5645833 L0.40625,7.90625 C0.143382353,7.65416667 0,7.31041667 0,6.96666667 C0,6.62291667 0.143382353,6.27916667 0.40625,6.02708333 L6.28492647,0.389583333 C6.54779412,0.1375 6.90625,0 7.26470588,0 C7.62316176,0 7.98161765,0.1375 8.24448529,0.389583333 L12.59375,4.56041667 C12.8566176,4.8125 13,5.15625 13,5.5 C13,5.84375 12.8566176,6.1875 12.59375,6.43958333 L9.36764706,9.53333333 L12.2352941,9.53333333 C12.6654412,9.53333333 13,9.85416667 13,10.2666667 C13,10.6791667 12.6654412,11 12.2352941,11 L5.35294118,11 Z"
            />
        </svg>
    );
};

export default React.memo(Eraser);
